module.exports = __webpack_public_path__ + "static/media/phone-alt.879b0568.svg";